import { ToastContainer, toast } from "react-toastify";

import { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Swal from "sweetalert2";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";

import FormFields from "../new-producteur-page/components/FormFields";
import { addNewMediaImgsApi } from "api/medias";

import { getOneProducerApi, updateProducerApi } from "api/superAdmin";
import { getEventImgListApi } from "api/producer";

function EditProducteur() {
  const navigate = useNavigate();
  const { producerId } = useParams();
  const [producerData, setProducerData] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formValues, setFormValues] = useState(null);

  const [isLimitedTickets, setIsLimitedTickets] = useState(false);
  const [isLimitedInvitations, setIsLimitedInvitations] = useState(false);
  const [eventImgList, setEventImgList] = useState([]);
  const [selectedEvents, setSelectedEvents] = useState([]);

  useEffect(() => {
    getEventImgListApi()
      .then((data) => setEventImgList(data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (producerId) {
      fetchProducerData();
    }
  }, [producerId]);

  const fetchProducerData = async () => {
    try {
      setIsLoading(true);
      const data = await getOneProducerApi(producerId);

      if (!data) {
        setIsLoading(false);
        setFormValues(null);
        setError("Données du producteur introuvables.");
        return;
      }

      setProducerData(data);

      const flatDataForForm = {
        _id: data._id,
        type: data.type,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        cin: data.cin,
        companyName: data.companyName,
        ice: data.ice,
        if: data.if,
        bankAccount: data.bankAccount,
        isActive: String(data.isActive),
        pseudo: data.pseudo,
        numberOfTickets: data.numberOfTickets?.numberOf || "",
        numberOfInvitations: data.numberOfInvitations?.numberOf || "",
      };

      setFormValues(flatDataForForm);

      setIsLimitedTickets(data.numberOfTickets?.isSelected || false);
      setIsLimitedInvitations(data.numberOfInvitations?.isSelected || false);
      setSelectedEvents((data.allowedEvents || []).map((id) => String(id)));

      setIsLoading(false);
      setError(null);
    } catch (err) {
      console.error("Error fetching producer data for edit:", err);
      setError(
        err.response?.data?.error || "Erreur lors de la récupération des données du producteur."
      );
      setIsLoading(false);
      setFormValues(null);
      setProducerData(null);
      setIsLimitedTickets(false);
      setIsLimitedInvitations(false);
    }
  };

  const handleUpdateProducer = async () => {
    try {
      const formattedValues = {
        ...formValues,
        numberOfTickets: formValues.numberOfTickets ? Number(formValues.numberOfTickets) : null,
        numberOfInvitations: formValues.numberOfInvitations
          ? Number(formValues.numberOfInvitations)
          : null,
      };

      await updateProducerApi(producerId, formattedValues, isLimitedTickets, isLimitedInvitations, selectedEvents);

      Swal.fire({
        title: "Mis à jour",
        text: "Les informations du producteur ont été mises à jour avec succès.",
        icon: "success",
      });

      navigate(`/producteurs/voir`);
    } catch (err) {
      console.error("Error updating producer:", err.response?.data?.error || err.message);
      toast.error(err.response?.data?.error || "Erreur lors de la mise à jour du producteur.");
    }
  };

  const handleGetFormValues = (value) => {
    try {
      const updatedValues = {
        ...value,
        numberOfTickets: value.numberOfTickets ? Number(value.numberOfTickets) : null,
        numberOfInvitations: value.numberOfInvitations ? Number(value.numberOfInvitations) : null,
      };
      setFormValues(updatedValues);
    } catch (err) {
      console.log(err);
    }
  };

  const handleInvitationValue = (value) => {
    try {
      setIsLimitedInvitations(value);
    } catch (err) {
      console.log(err);
    }
  };

  const handleTicketsValue = (value) => {
    try {
      setIsLimitedTickets(value);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <DashboardLayout>
      <ToastContainer />
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Mise à jour des informations du producteur
              </MDTypography>
              <MDBox mt={1} mb={2}>
                <MDTypography variant="body2" color="text"></MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={handleUpdateProducer}
                  disabled={isLoading || error || !formValues}
                >
                  Mettre à jour
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormFields
              initialData={formValues}
              formValues={handleGetFormValues}
              invitationValue={handleInvitationValue}
              ticketsValue={handleTicketsValue}
              initialIsLimitedTickets={isLimitedTickets}
              initialIsLimitedInvitations={isLimitedInvitations}
              eventImgList={eventImgList}
              selectedEvents={selectedEvents}
              onSelectedEventsChange={setSelectedEvents}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditProducteur;
